import { render, staticRenderFns } from "./ReportStatsCard.vue?vue&type=template&id=3c7728f8"
import script from "./ReportStatsCard.vue?vue&type=script&lang=js"
export * from "./ReportStatsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports